// Do not put any dispatcher here.
// Only pure API calls
// The Facades should mimic exactly the corresponding API.

import { useSweepApi } from '../sweep';
import {
  AssignmentGroup,
  CreditQueueRecord,
  CreditQueueUpdatePayload,
  CreditQueuePostPayload,
} from '../../reducers/assignmentGroupTypes';
import { useCallback } from 'react';
import { populateFieldsInfoFromSummary } from '../../sweep-fields/sweepFieldsInfoReducer';
import { useDispatch } from 'react-redux';
import { SweepFieldsSummaryMap } from '../../types/fields';

interface AssignmentGroupsResponse {
  groups: AssignmentGroup[];
  sweepFields: SweepFieldsSummaryMap;
}

interface AssignmentGroupResponse {
  group: AssignmentGroup;
  sweepFields: SweepFieldsSummaryMap;
}

export const useAssignmentGroupsApiFacade = () => {
  const sweepApi = useSweepApi();
  const dispatch = useDispatch();
  return {
    get_assignmentGroups: useCallback(async () => {
      const { data } = await sweepApi.get<AssignmentGroupsResponse>(`/assignment_groups`);
      dispatch(populateFieldsInfoFromSummary(data));

      return data;
    }, [dispatch, sweepApi]),

    get_assignmentGroup: useCallback(
      async (groupId: string) => {
        const { data } = await sweepApi.get<AssignmentGroupResponse>(
          `/assignment_groups/${groupId}`,
        );
        dispatch(populateFieldsInfoFromSummary(data));

        return data;
      },
      [dispatch, sweepApi],
    ),

    put_assignmentGroup: useCallback(
      async (groupId: string, assignmentGroup: AssignmentGroup) => {
        const { data } = await sweepApi.put<AssignmentGroup>(
          `/assignment_groups/${groupId}`,
          assignmentGroup,
        );
        return data;
      },
      [sweepApi],
    ),
    post_assignmentGroup: useCallback(
      async (assignmentGroupWithoutId: Omit<AssignmentGroup, 'id'>) => {
        const { data } = await sweepApi.post<AssignmentGroup>(
          `/assignment_groups`,
          assignmentGroupWithoutId,
        );
        return data;
      },
      [sweepApi],
    ),
    delete_assignmentGroup: useCallback(
      async (groupId: string) => {
        const { data } = await sweepApi.delete<AssignmentGroup>(`/assignment_groups/${groupId}`);
        return data;
      },
      [sweepApi],
    ),
    post_creditQueue: useCallback(
      async (payload: CreditQueuePostPayload) => {
        await sweepApi.post<void>(`/assignment_groups/credit-queue`, payload);
      },
      [sweepApi],
    ),
    get_creditQueue: useCallback(
      async (groupApiName: string) => {
        const { data } = await sweepApi.get<CreditQueueRecord[]>(
          `/assignment_groups/credit-queue?groupApiName=${groupApiName}`,
        );
        return data;
      },
      [sweepApi],
    ),
    put_creditQueue: useCallback(
      async (payload: CreditQueueUpdatePayload) => {
        await sweepApi.put<void>(`/assignment_groups/credit-queue`, payload);
      },
      [sweepApi],
    ),
  };
};
